<template>
  <div :style="{ marginTop: '20px', paddingBottom: '80px' }">

    <div v-if="!loading">

      <!-- Top-level enabled toggle -->
      <div class="d-flex align-items-center mb-3 alerts-global-row">
        <span class="alerts-global-label" style="min-width: auto; margin-right: 12px">Enabled</span>
        <b-form-select v-model="model.data_services_enabled" :options="boolean_options" style="width:100px"></b-form-select>
      </div>

      <!-- Smart Dispatching (admin only) -->
      <b-card v-if="isEffectiveAdmin" no-body class="alert-section-card mb-2" data-section="isSmartDispatchingVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isSmartDispatchingVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isSmartDispatchingVisible }">&#9654;</span>
          <span class="alert-section-title">Smart Dispatching Enabled</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.smart_dispatching_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isSmartDispatchingVisible" :visible="!!toggle.isSmartDispatchingVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="smart_dispatching_vehicle_types">
                <td class="alert-label">Supported Vehicle Types</td>
                <td><b-form-textarea v-model="model.smart_dispatching_vehicle_types" type="text" style="field-sizing: content"></b-form-textarea></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card v-if="isEffectiveAdmin" no-body class="alert-section-card mb-2" data-section="isRoutingVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isRoutingVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isRoutingVisible }">&#9654;</span>
          <span class="alert-section-title">Telematics Route Sync Enabled</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.routes_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isRoutingVisible" :visible="!!toggle.isRoutingVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr v-if="telematics_type=='SAMSARA'">
                <td class="alert-label">Routes - Assign To Drivers</td>
                <td><b-form-select v-model="model.routes_assign_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="telematics_type=='SAMSARA'">
                <td class="alert-label">Routes - Assign To Drivers Then Vehicles</td>
                <td><b-form-select v-model="model.routes_assign_to_driver_then_vehicle" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="telematics_type=='SAMSARA' && tenant_type=='TBN'">
                <td class="alert-label">Route - Assign Vehicles To Existing Routes</td>
                <td><b-form-select v-model="model.routes_vehicle_assignments_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type=='TBN' && telematics_type=='SAUCON'">
                <td class="alert-label">Route - Assign To Existing Saucon Routes</td>
                <td><b-form-select v-model="model.routes_saucon_assignments_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type=='TBN'">
                <td class="alert-label">Route - Assign To Existing Routes Filter</td>
                <td><b-form-input v-model="model.routes_vehicle_assignments_filter" type="text"></b-form-input></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>
      
      
      <!-- Tyler Route Sync (TBN only) -->
      <b-card v-if="tenant_type === 'TBN'" no-body class="alert-section-card mb-2" data-section="isTylerSyncVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isTylerSyncVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isTylerSyncVisible }">&#9654;</span>
          <span class="alert-section-title">Tyler Route Sync Enabled</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.tbn_tyler_route_sync_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isTylerSyncVisible" :visible="!!toggle.isTylerSyncVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="tbn_tyler_route_sync_mapping">
                <td class="alert-label">Tyler → TBN Route Mapping</td>
                <td>
                  <JsonObjectListEditor v-model="model.tbn_tyler_route_sync_mapping" fieldKey="tbn_tyler_route_sync_mapping" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="tyler_route_sync_mapping_columns"/>
                  <b-form-invalid-feedback :state="jsonState('tbn_tyler_route_sync_mapping')">{{ jsonFeedback('tbn_tyler_route_sync_mapping') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="tbn_tyler_route_sync_keys">
                <td class="alert-label">Tyler Route Sync Keys</td>
                <td>
                  <!-- fullstory: fs-exclude so tyler api keys are never captured -->
                  <JsonObjectListEditor v-model="model.tbn_tyler_route_sync_keys" fieldKey="tbn_tyler_route_sync_keys" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="tyler_route_sync_keys_columns" class="fs-exclude"/>
                  <b-form-invalid-feedback :state="jsonState('tbn_tyler_route_sync_keys')">{{ jsonFeedback('tbn_tyler_route_sync_keys') }}</b-form-invalid-feedback>
                </td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Sync Drivers -->
      <b-card no-body class="alert-section-card mb-2" data-section="isSyncDriversVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isSyncDriversVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isSyncDriversVisible }">&#9654;</span>
          <span class="alert-section-title">Sync Drivers Enabled</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.data_services_compare_drivers_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isSyncDriversVisible" :visible="!!toggle.isSyncDriversVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="avatar_api_url">
                <td class="alert-label">Avatar API URL</td>
                <td><b-form-input v-model="model.avatar_api_url" type="text"></b-form-input></td>
              </tr>
              <tr data-field="avatar_api_token">
                <td class="alert-label">Avatar API Token</td>
                <td><b-form-input v-model="model.avatar_api_token" type="text" class="fs-exclude"></b-form-input></td>
              </tr>
              <tr data-field="data_services_compare_drivers_add_enabled">
                <td class="alert-label">Compare Drivers Add Enabled</td>
                <td><b-form-select v-model="model.data_services_compare_drivers_add_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="data_services_compare_drivers_avatar_job_filters">
                <td class="alert-label">Avatar Job Filters</td>
                <td>
                  <b-form-input v-model="model.data_services_compare_drivers_avatar_job_filters" type="text" :state="filterState('data_services_compare_drivers_avatar_job_filters')" @input="validateFilter('data_services_compare_drivers_avatar_job_filters', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('data_services_compare_drivers_avatar_job_filters')">{{ filterFeedback('data_services_compare_drivers_avatar_job_filters') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="data_services_compare_drivers_avatar_status_filters">
                <td class="alert-label">Avatar Statuses To Exclude</td>
                <td>
                  <b-form-input v-model="model.data_services_compare_drivers_avatar_status_filters" type="text" :state="filterState('data_services_compare_drivers_avatar_status_filters')" @input="validateFilter('data_services_compare_drivers_avatar_status_filters', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('data_services_compare_drivers_avatar_status_filters')">{{ filterFeedback('data_services_compare_drivers_avatar_status_filters') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="data_services_compare_drivers_avatar_driver_name_filter">
                <td class="alert-label">Avatar Driver Name Filters</td>
                <td>
                  <b-form-input v-model="model.data_services_compare_drivers_avatar_driver_name_filter" type="text" :state="filterState('data_services_compare_drivers_avatar_driver_name_filter')" @input="validateFilter('data_services_compare_drivers_avatar_driver_name_filter', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('data_services_compare_drivers_avatar_driver_name_filter')">{{ filterFeedback('data_services_compare_drivers_avatar_driver_name_filter') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="data_services_compare_drivers_avatar_tbn_status_map">
                <td class="alert-label">Avatar To TBN Status Mapping</td>
                <td>
                  <JsonKeyValueEditor v-model="model.data_services_compare_drivers_avatar_tbn_status_map" fieldKey="data_services_compare_drivers_avatar_tbn_status_map" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" keyLabel="Avatar Status" valueLabel="TBN Status"/>
                  <b-form-invalid-feedback :state="jsonState('data_services_compare_drivers_avatar_tbn_status_map')">{{ jsonFeedback('data_services_compare_drivers_avatar_tbn_status_map') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="data_services_compare_drivers_avatar_samsara_status_map">
                <td class="alert-label">Avatar To Samsara Tags Mapping</td>
                <td>
                  <JsonKeyValueEditor v-model="model.data_services_compare_drivers_avatar_samsara_status_map" fieldKey="data_services_compare_drivers_avatar_samsara_status_map" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" keyLabel="Avatar Status" valueLabel="Samsara Tag"/>
                  <b-form-invalid-feedback :state="jsonState('data_services_compare_drivers_avatar_samsara_status_map')">{{ jsonFeedback('data_services_compare_drivers_avatar_samsara_status_map') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="data_services_compare_drivers_tbn_location_filters">
                <td class="alert-label">TBN Location Filters</td>
                <td>
                  <b-form-input v-model="model.data_services_compare_drivers_tbn_location_filters" type="text" :state="filterState('data_services_compare_drivers_tbn_location_filters')" @input="validateFilter('data_services_compare_drivers_tbn_location_filters', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('data_services_compare_drivers_tbn_location_filters')">{{ filterFeedback('data_services_compare_drivers_tbn_location_filters') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="data_services_compare_drivers_tbn_driver_name_filter">
                <td class="alert-label">TBN Driver Name Filters</td>
                <td>
                  <b-form-input v-model="model.data_services_compare_drivers_tbn_driver_name_filter" type="text" :state="filterState('data_services_compare_drivers_tbn_driver_name_filter')" @input="validateFilter('data_services_compare_drivers_tbn_driver_name_filter', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('data_services_compare_drivers_tbn_driver_name_filter')">{{ filterFeedback('data_services_compare_drivers_tbn_driver_name_filter') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="data_services_compare_drivers_auto_sync_profiles_nightly_enabled">
                <td class="alert-label">Auto Sync Profiles Nightly</td>
                <td><b-form-select v-model="model.data_services_compare_drivers_auto_sync_profiles_nightly_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="data_services_compare_drivers_auto_sync_profiles_nightly_email_recipients">
                <td class="alert-label">Auto Sync Profiles Nightly Email Recipients</td>
                <td><b-form-input v-model="model.data_services_compare_drivers_auto_sync_profiles_nightly_email_recipients" type="text" placeholder="email1@example.com,email2@example.com"></b-form-input></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Driver Scorecard -->
      <b-card no-body class="alert-section-card mb-2" data-section="isScorecardVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isScorecardVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isScorecardVisible }">&#9654;</span>
          <span class="alert-section-title">Driver Scorecard</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.driver_scorecard_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isScorecardVisible" :visible="!!toggle.isScorecardVisible">
          <b-card-body>
            <!-- Compiled Performance Score Weights -->
            <div class="weights-panel mb-3" data-field="scorecard_compiled_weights">
              <div class="weights-panel-header">
                <span class="weights-panel-title">Compiled Performance Score Weights</span>
                <div class="d-flex align-items-center" style="gap:8px">
                  <button type="button" class="weights-reset-btn" @click="resetWeightsToDefaults">Reset to defaults</button>
                  <span class="weights-total-chip" :class="weightsTotalChipClass">{{ weightsTotal }} / 100</span>
                </div>
              </div>
              <div class="weights-grid">
                <div v-for="field in compiled_weights_fields" :key="field.key" class="weight-row">
                  <span class="weight-metric-label">{{ field.label }}</span>
                  <button type="button" class="weight-btn" @click="adjustWeight(field.key, -1)">−</button>
                  <input type="number" class="weight-num" v-model.number="compiled_weights_model[field.key]" min="0" max="100" step="1" />
                  <button type="button" class="weight-btn" @click="adjustWeight(field.key, 1)">+</button>
                  <span class="weight-pct">%</span>
                  <div class="weight-bar-track">
                    <div class="weight-bar-fill" :style="{ width: barWidth(field.key) + '%' }"></div>
                  </div>
                </div>
              </div>
              <p class="weights-hint" v-if="weightsTotal > 0 && weightsTotal !== 100">Weights are normalized proportionally — they don't need to sum to 100.</p>
            </div>
            <!-- Conditional Coloring / Thresholds -->
            <div data-field="scorecard_thresholds">
              <span class="alert-label d-inline-block" style="margin-right: 12px">Conditional Coloring</span>
              <button type="button" class="weights-reset-btn" style="font-size:13px; padding: 5px 16px;" @click="show_thresholds_modal = true">
                Customize Score Thresholds
              </button>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Advanced (admin only) -->
      <b-card v-if="isEffectiveAdmin" no-body class="alert-section-card mb-2" data-section="isAdvVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isAdvVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isAdvVisible }">&#9654;</span>
          <span class="alert-section-title">Advanced</span>
        </b-card-header>
        <b-collapse id="collapse-isAdvVisible" :visible="!!toggle.isAdvVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="booking_customer_portal_enabled">
                <td class="alert-label">Booking Customer Portal Enabled</td>
                <td><b-form-select v-model="model.booking_customer_portal_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- ===================== Scorecard Thresholds Modal ===================== -->
      <b-modal
        v-model="show_thresholds_modal"
        title="Driver Scorecard Thresholds"
        size="xl"
        hide-footer
        @show="onThresholdsModalShow"
      >
        <div class="thresholds-modal-body">
          <p class="thresholds-intro">
            Customize the boundaries that determine green / amber / red coloring on the driver scorecard.
            Changes apply the next time a scorecard is loaded.
          </p>

          <!-- One card per active field — tier drives which slider variant is rendered -->
          <div v-for="key in active_threshold_keys" :key="key" class="threshold-field-card">
            <div class="threshold-field-header">
              <span class="threshold-field-label">{{ fieldConfig(key).label }}</span>
              <span class="threshold-field-direction">
                {{ fieldConfig(key).direction === 'higher_better' ? 'higher is better' : 'lower is better' }}
                <template v-if="fieldConfig(key).tier === '4'"> — 4 tiers</template>
              </span>
              <button type="button" class="threshold-remove-btn" @click="removeField(key)" title="Remove field">×</button>
            </div>

            <!-- 3-tier: dual-handle (good + warning) -->
            <template v-if="fieldConfig(key).tier === '3'">
              <div class="dual-range-wrap" :style="sliderGradientStyle(key)">
                <input type="range" class="dual-range-input"
                  :min="0" :max="fieldConfig(key).scale" :step="fieldConfig(key).step"
                  v-model.number="thresholds_model[key].warning"
                  :style="{ zIndex: thresholds_model[key].warning >= thresholds_model[key].good ? 5 : 3 }"
                />
                <input type="range" class="dual-range-input"
                  :min="0" :max="fieldConfig(key).scale" :step="fieldConfig(key).step"
                  v-model.number="thresholds_model[key].good"
                  :style="{ zIndex: thresholds_model[key].good > thresholds_model[key].warning ? 5 : 3 }"
                />
              </div>
              <div class="slider-readout-row">
                <template v-if="fieldConfig(key).direction === 'higher_better'">
                  <div class="readout-end readout-left">
                    <span class="tier-bad readout-tier">Bad</span>
                    <span class="readout-sep">&lt;</span>
                    <input type="number" class="threshold-num" :class="{ 'threshold-input-error': thresholdErrors[key] }"
                      v-model.number="thresholds_model[key].warning" :step="fieldConfig(key).step" :min="0" :max="fieldConfig(key).scale" />
                    <span class="readout-unit">Warning</span>
                  </div>
                  <div class="readout-end readout-right">
                    <span class="readout-unit">Good</span>
                    <input type="number" class="threshold-num" :class="{ 'threshold-input-error': thresholdErrors[key] }"
                      v-model.number="thresholds_model[key].good" :step="fieldConfig(key).step" :min="0" :max="fieldConfig(key).scale" />
                    <span class="readout-sep">&le;</span>
                    <span class="tier-good readout-tier">Good</span>
                  </div>
                </template>
                <template v-else>
                  <div class="readout-end readout-left">
                    <span class="tier-good readout-tier">Good</span>
                    <span class="readout-sep">&lt;</span>
                    <input type="number" class="threshold-num" :class="{ 'threshold-input-error': thresholdErrors[key] }"
                      v-model.number="thresholds_model[key].good" :step="fieldConfig(key).step" :min="0" :max="fieldConfig(key).scale" />
                    <span class="readout-unit">Good cutoff</span>
                  </div>
                  <div class="readout-end readout-right">
                    <span class="readout-unit">Bad cutoff</span>
                    <input type="number" class="threshold-num" :class="{ 'threshold-input-error': thresholdErrors[key] }"
                      v-model.number="thresholds_model[key].warning" :step="fieldConfig(key).step" :min="0" :max="fieldConfig(key).scale" />
                    <span class="readout-sep">&lt;</span>
                    <span class="tier-bad readout-tier">Bad</span>
                  </div>
                </template>
              </div>
            </template>

            <!-- 2-tier: single-handle (good cutoff only, e.g. customer requests) -->
            <template v-else-if="fieldConfig(key).tier === '2'">
              <div class="dual-range-wrap" :style="sliderGradientStyle(key)">
                <input type="range" class="dual-range-input" style="z-index:5;"
                  :min="fieldConfig(key).minVal || 0" :max="fieldConfig(key).scale" :step="fieldConfig(key).step"
                  v-model.number="thresholds_model[key].good"
                />
              </div>
              <div class="slider-readout-row">
                <div class="readout-end readout-left">
                  <span class="tier-warning readout-tier">Warning</span>
                  <span class="readout-sep">&lt;</span>
                  <span class="readout-unit" style="font-weight:600; font-size:14px;">{{ fieldConfig(key).minVal || 0 }}</span>
                </div>
                <div class="readout-end readout-right">
                  <span class="readout-unit">Good cutoff</span>
                  <input type="number" class="threshold-num" :class="{ 'threshold-input-error': thresholdErrors[key] }"
                    v-model.number="thresholds_model[key].good"
                    :step="fieldConfig(key).step" :min="fieldConfig(key).minVal || 0" :max="fieldConfig(key).scale" />
                  <span class="readout-sep">&le;</span>
                  <span class="tier-good readout-tier">Good</span>
                </div>
              </div>
            </template>

            <!-- 4-tier: triple-handle (compiled score) -->
            <template v-else-if="fieldConfig(key).tier === '4'">
              <div class="dual-range-wrap" :style="sliderGradientStyle(key)">
                <input type="range" class="dual-range-input" min="0" max="100" step="1"
                  v-model.number="thresholds_model[key].coaching"
                  :style="{ zIndex: compiledHandleZIndex('coaching') }"
                />
                <input type="range" class="dual-range-input" min="0" max="100" step="1"
                  v-model.number="thresholds_model[key].solid"
                  :style="{ zIndex: compiledHandleZIndex('solid') }"
                />
                <input type="range" class="dual-range-input" min="0" max="100" step="1"
                  v-model.number="thresholds_model[key].elite"
                  :style="{ zIndex: compiledHandleZIndex('elite') }"
                />
              </div>
              <div class="slider-readout-row compiled-readout-row">
                <div class="readout-end readout-left">
                  <span class="tier-bad readout-tier">High Risk</span>
                  <span class="readout-sep">&lt;</span>
                  <input type="number" class="threshold-num" :class="{ 'threshold-input-error': thresholdErrors[key] }"
                    v-model.number="thresholds_model[key].coaching" step="1" min="0" max="100" />
                  <span class="readout-unit">Coaching</span>
                </div>
                <div class="readout-end readout-center">
                  <span class="readout-unit">Solid</span>
                  <input type="number" class="threshold-num" :class="{ 'threshold-input-error': thresholdErrors[key] }"
                    v-model.number="thresholds_model[key].solid" step="1" min="0" max="100" />
                </div>
                <div class="readout-end readout-right">
                  <span class="readout-unit">Elite</span>
                  <input type="number" class="threshold-num" :class="{ 'threshold-input-error': thresholdErrors[key] }"
                    v-model.number="thresholds_model[key].elite" step="1" min="0" max="100" />
                  <span class="readout-sep">&le;</span>
                  <span class="tier-elite readout-tier">Elite</span>
                </div>
              </div>
            </template>

            <div v-if="thresholdErrors[key]" class="threshold-error-msg">{{ thresholdErrors[key] }}</div>
          </div>

          <!-- Add optional field -->
          <div class="threshold-add-row">
            <b-form-select v-model="field_to_add" :options="addableFieldOptions" style="width:auto; min-width:240px; font-size:13px;" />
            <b-btn variant="outline-primary" size="sm" :disabled="!field_to_add" @click="addField">+ Add Field</b-btn>
          </div>

          <div class="thresholds-modal-footer">
            <button type="button" class="weights-reset-btn" @click="resetThresholdsToDefaults">Reset to Defaults</button>
            <div style="display:flex; gap:8px;">
              <b-btn variant="secondary" @click="show_thresholds_modal = false">Cancel</b-btn>
              <b-btn variant="success" :disabled="hasThresholdErrors || saving_thresholds" @click="saveThresholds">
                <b-spinner v-if="saving_thresholds" small style="margin-right:4px;" />
                Save
              </b-btn>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

    <div class="tc-sticky-save">
      <transition name="tc-save-slide">
      <div v-if="isDirty || saving" class="d-flex align-items-center justify-content-center">
        <span v-if="isDirty && !saving" class="tc-unsaved-label mr-3" @click="scrollToFirstDirtyField()" title="Click to scroll to unsaved field" style="cursor:pointer">&#9679; Unsaved changes</span>
        <b-btn size="lg" variant="success" @click="save_config" :disabled="saving">
          <b-spinner v-if="saving" small class="mr-1"></b-spinner>
          {{ saving ? 'Saving...' : 'Save' }}
        </b-btn>
        &nbsp;&nbsp;
        <b-btn size="lg" variant="secondary" @click="load_data(true)">Discard Changes</b-btn>
      </div>
      </transition>
    </div>
  </div>

</template>
<script>
import {get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
import filterValidationMixin from '../mixins/filter_validation_mixin'
import {mapState} from "vuex";
import jsonValidationMixin from '../mixins/json_validation_mixin'
import dirtyTrackingMixin from '../mixins/dirty_tracking_mixin'
import JsonKeyValueEditor from './JsonKeyValueEditor.vue'
import JsonObjectListEditor from './JsonObjectListEditor.vue'
import { DEFAULT_SCORECARD_THRESHOLDS, OPTIONAL_SCORECARD_DEFAULTS, THRESHOLD_FIELD_CONFIG, DEFAULT_THRESHOLD_KEYS } from '../utils/scorecard_thresholds'

function buildDefaultThresholdsModel() {
  const model = {}
  for (const [key, cfg] of Object.entries(THRESHOLD_FIELD_CONFIG)) {
    const src = DEFAULT_SCORECARD_THRESHOLDS[key] || OPTIONAL_SCORECARD_DEFAULTS[key] || {}
    if (cfg.tier === '4') {
      model[key] = { elite: src.elite, solid: src.solid, coaching: src.coaching }
    } else if (cfg.tier === '2') {
      model[key] = { good: src.good }
    } else {
      model[key] = { good: src.good, warning: src.warning }
    }
  }
  return model
}

export default {
  name: 'tenant_config',
  mixins: [filterValidationMixin, jsonValidationMixin, dirtyTrackingMixin],
  components: {
    JsonKeyValueEditor,
    JsonObjectListEditor,
  },

  data() {
    return {
      group_name: 'general',
      add_yard_model: {},
      manage_sos_yards: false,
      model: {},
      general_model: {},
      general_advanced_model: {},
      toggle: {
        isSmartDispatchingVisible: false,
        isTylerSyncVisible: false,
        isSyncDriversVisible: false,
        isScorecardVisible: false,
        isAdvVisible: false,
      },
      summary: {},
      loading: true,
      isNotSysadmin: false,
      isSamaraType: false,
      yardsLength: 0,
      objectKeyList: [],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
      tyler_route_sync_mapping_columns: [
        { key: 'contractName', label: 'TBN Contract Name', placeholder: 'e.g. Bloomfield BOE (2025-26)' },
        { key: 'tylerPath', label: 'Tyler Path', placeholder: 'e.g. CTDATTCOPlainvilleSD' },
      ],
      tyler_route_sync_keys_columns: [
        { key: 'contractName', label: 'TBN Contract Name', placeholder: 'e.g. Bloomfield BOE (2025-26)' },
        { key: 'apiKey', label: 'API Key', placeholder: 'Tyler API key' },
      ],
      fieldPrefixSectionMap: [
        ['smart_dispatching_', 'isSmartDispatchingVisible'],
        ['tbn_tyler_', 'isTylerSyncVisible'],
        ['data_services_compare_drivers_', 'isSyncDriversVisible'],
        ['avatar_', 'isSyncDriversVisible'],
        ['driver_scorecard_', 'isScorecardVisible'],
        ['booking_customer_portal_', 'isAdvVisible'],
      ],
      jsonFieldToggleMap: {
        tbn_tyler_route_sync_mapping: 'isTylerSyncVisible',
        tbn_tyler_route_sync_keys: 'isTylerSyncVisible',
        tbn_tyler_contract_driver_time_offsets: 'isTylerSyncVisible',
        data_services_compare_drivers_avatar_tbn_status_map: 'isSyncDriversVisible',
        data_services_compare_drivers_avatar_samsara_status_map: 'isSyncDriversVisible',
        scorecard_compiled_weights: 'isScorecardVisible',
        scorecard_thresholds: 'isScorecardVisible',
      },
      compiled_weights_fields: [
        { key: 'risk_score',                        label: 'Risk Score' },
        { key: 'speeding_percentage',               label: 'Speeding %' },
        { key: 'idling_percentage',                 label: 'Idling %' },
        { key: 'following_distance_per_10k_miles',  label: 'Following Distance / 10k' },
        { key: 'distracted_driving_percentage',     label: 'Distracted Driving / 10k' },
        { key: 'weekend_availability_percentage',   label: 'Weekend Availability %' },
        { key: 'customer_requests_per_10k_miles',   label: 'Customer Requests / 10k' },
        { key: 'dvir_completion_rate',              label: 'DVIR Completion %' },
      ],
      compiled_weights_model: {
        risk_score: 40,
        speeding_percentage: 10,
        idling_percentage: 15,
        following_distance_per_10k_miles: 5,
        distracted_driving_percentage: 5,
        weekend_availability_percentage: 10,
        customer_requests_per_10k_miles: 10,
        dvir_completion_rate: 5,
      },
      // Keys shown in the threshold modal
      active_threshold_keys: [...DEFAULT_THRESHOLD_KEYS],
      field_to_add: null,
      saving_thresholds: false,
      show_thresholds_modal: false,
      thresholds_model: buildDefaultThresholdsModel(),
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    async load_data(silent = false) {
      if (!silent) this.loading = true
      this.objectKeyList = []
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results

        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
          // always treat these as JSON fields even when not yet set in DDB
          if (!this.objectKeyList.includes('scorecard_compiled_weights')) {
            this.objectKeyList.push('scorecard_compiled_weights')
          }
          if (!this.objectKeyList.includes('scorecard_thresholds')) {
            this.objectKeyList.push('scorecard_thresholds')
          }
          if (!this.objectKeyList.includes('tbn_tyler_route_sync_mapping')) {
            this.objectKeyList.push('tbn_tyler_route_sync_mapping')
          }
          this.model.tbn_tyler_route_sync_mapping = this.migrateTylerRouteSyncMapping(this.model.tbn_tyler_route_sync_mapping)
        } catch(e) {
          console.log('error looping through keys',e)
        }

        // parse compiled weights into the structured spinbutton model
        try {
          const raw = this.model.scorecard_compiled_weights
          const parsed = raw ? (typeof raw === 'string' ? JSON.parse(raw) : raw) : null
          if (parsed && Object.keys(parsed).length > 0) {
            for (const f of this.compiled_weights_fields) {
              this.$set(this.compiled_weights_model, f.key, Number(parsed[f.key]) || 0)
            }
          }
          // if no weights are saved yet, compiled_weights_model stays at the defaults set in data()
        } catch(e) {
          // leave defaults in place on parse error
        }

        // Sync compiled_weights_model → model immediately so the snapshot
        // always includes scorecard_compiled_weights (even for new tenants
        // where it's absent from the API response). Without this, clicking
        // +/- back to the original value would still appear dirty because
        // the snapshot wouldn't have the key at all.
        const weightsObj = {}
        for (const f of this.compiled_weights_fields) {
          const v = Number(this.compiled_weights_model[f.key]) || 0
          if (v > 0) weightsObj[f.key] = v
        }
        this.$set(this.model, 'scorecard_compiled_weights', Object.keys(weightsObj).length ? JSON.stringify(weightsObj) : '')

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
      this._resetDirtyTracking()
      this.saving = false
    },
    async save_config() {
      try {
        this.saving = true
        this.flushFilterValidation()
        if (this.hasFilterErrors()) {
          this.$emit('showAlert', 'Fix the highlighted filter field before saving', 'danger', 6000)
          this.scrollToFirstFilterError()
          this.saving = false
          return
        }
        if (this.hasJsonErrors()) {
          this.$emit('showAlert', 'Invalid JSON in field: ' + this.firstJsonErrorKey() + ' — ' + this.jsonFeedback(this.firstJsonErrorKey()), 'danger', 8000)
          this.expandAndScrollToJsonError()
          this.saving = false
          return
        }
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        const payload = Object.assign({}, this.model)
        for (const objkey of this.objectKeyList) {
          try {
            if (payload[objkey] && payload[objkey].trim && payload[objkey].trim() !== '') {
              payload[objkey] = JSON.parse(payload[objkey])
            }
          } catch (e) {
            this.$emit('showAlert', 'Invalid JSON in field: ' + objkey + ' — ' + e.message, 'danger', 8000)
            this.expandAndScrollToJsonError()
            this.load_data()
            return
          }
        }
        await update_tenant_config_settings(this.user.tenant, payload, this.group_name)
        this.load_data(true)
        this.$emit('showAlert', 'Configuration Saved', 'success',5000)
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
        this.saving = false
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item, field, setting) {
      if (item[field] !== setting) {
        this.$set(item, field, setting)
      }
    },
    toggle_div(item, field) {
      this.$set(item, field, !item[field])
    },
    migrateTylerRouteSyncMapping(value) {
      if (value == null || value === '') {
        return ''
      }
      if (Array.isArray(value)) {
        return JSON.stringify(value)
      }
      if (typeof value !== 'string') {
        return ''
      }
      const trimmed = value.trim()
      if (!trimmed) {
        return ''
      }
      if (trimmed.startsWith('[')) {
        return value
      }
      const entries = trimmed.split(',').map(part => {
        const segments = part.trim().split(':')
        if (segments.length < 2) {
          return null
        }
        return {
          contractName: segments[0].replace(/\n/g, '').trim(),
          tylerPath: segments.slice(1).join(':').replace(/\n/g, '').trim(),
        }
      }).filter(entry => entry && entry.contractName && entry.tylerPath)
      return entries.length ? JSON.stringify(entries) : ''
    },
    isPlainObject(value,key) {
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value) {
      return Array.isArray(value)
    },

    // --- Compiled weights ---
    adjustWeight(key, delta) {
      const current = Number(this.compiled_weights_model[key]) || 0
      this.$set(this.compiled_weights_model, key, Math.min(100, Math.max(0, current + delta)))
    },
    resetWeightsToDefaults() {
      const defaults = { risk_score: 40, idling_percentage: 15, speeding_percentage: 10, following_distance_per_10k_miles: 5, weekend_availability_percentage: 10, customer_requests_per_10k_miles: 10, distracted_driving_percentage: 5, dvir_completion_rate: 5 }
      for (const f of this.compiled_weights_fields) {
        this.$set(this.compiled_weights_model, f.key, defaults[f.key] || 0)
      }
    },
    barWidth(key) {
      const total = this.weightsTotal
      if (total === 0) return 0
      return Math.round(((Number(this.compiled_weights_model[key]) || 0) / total) * 100)
    },

    // --- Scorecard thresholds modal ---
    _buildDefaultThresholdsModel() {
      return buildDefaultThresholdsModel()
    },
    onThresholdsModalShow() {
      this.field_to_add = null
      this.$set(this, 'thresholds_model', this._buildDefaultThresholdsModel())

      try {
        const raw = this.model.scorecard_thresholds
        const saved = raw ? (typeof raw === 'string' ? JSON.parse(raw) : raw) : null

        if (saved !== null && saved !== undefined) {
          // Tenant has explicitly saved before (even if they saved zero fields) — honour it
          for (const key of Object.keys(this.thresholds_model)) {
            if (saved[key] && typeof saved[key] === 'object') {
              this.$set(this.thresholds_model, key, { ...this.thresholds_model[key], ...saved[key] })
            }
          }
          // Active keys = only what the tenant explicitly saved, in canonical display order
          const ALL_KEYS = Object.keys(THRESHOLD_FIELD_CONFIG)
          this.$set(this, 'active_threshold_keys', ALL_KEYS.filter(k => k in saved))
        } else {
          // Never configured — show all defaults as a starting point
          this.$set(this, 'active_threshold_keys', [...DEFAULT_THRESHOLD_KEYS])
        }
      } catch(e) {
        // leave defaults on parse error
        this.$set(this, 'active_threshold_keys', [...DEFAULT_THRESHOLD_KEYS])
      }
    },
    resetThresholdsToDefaults() {
      this.$set(this, 'active_threshold_keys', [...DEFAULT_THRESHOLD_KEYS])
      this.field_to_add = null
      this.$set(this, 'thresholds_model', this._buildDefaultThresholdsModel())
    },
    saveThresholds() {
      if (this.hasThresholdErrors || this.saving_thresholds) return
      // Build the payload from active fields only
      const out = {}
      for (const key of this.active_threshold_keys) {
        if (this.thresholds_model[key]) out[key] = this.thresholds_model[key]
      }
      // Optimistic update: close immediately and update local model so the scorecard re-renders
      // without waiting for the round trip. On API failure the alert is shown but the local
      // model is NOT reverted — a page refresh will restore the last successfully persisted state.
      this.model.scorecard_thresholds = JSON.stringify(out)
      this.show_thresholds_modal = false
      this.saving_thresholds = true
      update_tenant_config_settings(this.user.tenant, { scorecard_thresholds: out })
        .then(() => {
          this.$emit('showAlert', 'Conditional coloring saved', 'success', 4000)
        })
        .catch((e) => {
          console.error('saveThresholds error:', e)
          this.$emit('showAlert', 'Error saving thresholds — check console', 'danger', 8000)
        })
        .finally(() => {
          this.saving_thresholds = false
        })
    },
    fieldConfig(key) {
      return THRESHOLD_FIELD_CONFIG[key] || {}
    },
    addField() {
      if (!this.field_to_add || this.active_threshold_keys.includes(this.field_to_add)) return
      this.active_threshold_keys.push(this.field_to_add)
      this.field_to_add = null
    },
    removeField(key) {
      const idx = this.active_threshold_keys.indexOf(key)
      if (idx !== -1) this.active_threshold_keys.splice(idx, 1)
    },
    sliderGradientStyle(key) {
      const cfg = THRESHOLD_FIELD_CONFIG[key]
      if (!cfg) return {}
      const m = this.thresholds_model[key]
      if (!m) return {}
      const scale = cfg.scale || 100

      if (cfg.tier === '4') {
        const elite    = Math.min(Math.max(Number(m.elite)    || 85, 0), 100)
        const solid    = Math.min(Math.max(Number(m.solid)    || 65, 0), 100)
        const coaching = Math.min(Math.max(Number(m.coaching) || 40, 0), 100)
        return { background: `linear-gradient(to right, #dc3545 0%, #dc3545 ${coaching}%, #ffc107 ${coaching}%, #ffc107 ${solid}%, #007bff ${solid}%, #007bff ${elite}%, #28a745 ${elite}%, #28a745 100%)` }
      }

      if (cfg.tier === '2') {
        const minVal = cfg.minVal || 0
        const good   = Math.min(Math.max(Number(m.good) || minVal, minVal), scale)
        const pct    = (good / scale) * 100
        return { background: `linear-gradient(to right, #ffc107 0%, #ffc107 ${pct}%, #28a745 ${pct}%, #28a745 100%)` }
      }

      // 3-tier
      const good    = Math.min(Math.max(Number(m.good)    || 0, 0), scale)
      const warning = Math.min(Math.max(Number(m.warning) || 0, 0), scale)
      const gPct = (good    / scale) * 100
      const wPct = (warning / scale) * 100
      let gradient
      if (cfg.direction === 'higher_better') {
        gradient = `linear-gradient(to right, #dc3545 0%, #dc3545 ${wPct}%, #ffc107 ${wPct}%, #ffc107 ${gPct}%, #28a745 ${gPct}%, #28a745 100%)`
      } else {
        gradient = `linear-gradient(to right, #28a745 0%, #28a745 ${gPct}%, #ffc107 ${gPct}%, #ffc107 ${wPct}%, #dc3545 ${wPct}%, #dc3545 100%)`
      }
      return { background: gradient }
    },
    compiledHandleZIndex(tier) {
      const cs = this.thresholds_model.compiled_score
      if (!cs) return 3
      const values = { coaching: Number(cs.coaching) || 0, solid: Number(cs.solid) || 0, elite: Number(cs.elite) || 0 }
      const sorted = Object.entries(values).sort((a, b) => a[1] - b[1]).map(e => e[0])
      return sorted.indexOf(tier) + 3
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user,
      viewAs: state => state.profile.view_as,
    }),
    isEffectiveAdmin() {
      return this.user.role === 'admin' && this.viewAs !== 'non-admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    },
    weightsTotal() {
      return this.compiled_weights_fields.reduce((sum, f) => sum + (Number(this.compiled_weights_model[f.key]) || 0), 0)
    },
    weightsTotalChipClass() {
      const t = this.weightsTotal
      if (t === 0) return 'chip-neutral'
      if (t === 100) return 'chip-success'
      return 'chip-warning'
    },
    thresholdErrors() {
      const errors = {}
      for (const key of this.active_threshold_keys) {
        const cfg = THRESHOLD_FIELD_CONFIG[key]
        const m   = this.thresholds_model[key]
        if (!cfg || !m) continue

        if (cfg.tier === '4') {
          const e = Number(m.elite), s = Number(m.solid), c = Number(m.coaching)
          if (isNaN(e) || isNaN(s) || isNaN(c)) {
            errors[key] = 'Values must be numbers'
          } else if (!(e > s && s > c && c >= 0)) {
            errors[key] = 'Tiers must be in descending order: Elite > Solid > Coaching ≥ 0'
          }
        } else if (cfg.tier === '2') {
          const minVal = cfg.minVal || 0
          const good = Number(m.good)
          if (isNaN(good) || good < minVal) {
            errors[key] = minVal > 0
              ? `Good threshold must be at least ${minVal}`
              : 'Good threshold must be greater than 0'
          }
        } else {
          // 3-tier
          const good    = Number(m.good)
          const warning = Number(m.warning)
          if (isNaN(good) || isNaN(warning)) {
            errors[key] = 'Values must be numbers'
          } else if (cfg.direction === 'higher_better' && good <= warning) {
            errors[key] = 'Good threshold must be greater than Warning threshold'
          } else if (cfg.direction === 'lower_better' && good >= warning) {
            errors[key] = 'Good threshold must be less than Warning threshold'
          }
        }
      }
      return errors
    },
    hasThresholdErrors() {
      return Object.keys(this.thresholdErrors).length > 0
    },
    addableFieldOptions() {
      const opts = [{ value: null, text: 'Select a field to add...' }]
      for (const key of Object.keys(THRESHOLD_FIELD_CONFIG)) {
        if (!this.active_threshold_keys.includes(key)) {
          opts.push({ value: key, text: THRESHOLD_FIELD_CONFIG[key].label })
        }
      }
      return opts
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    },
    compiled_weights_model: {
      deep: true,
      handler(val) {
        const obj = {}
        for (const f of this.compiled_weights_fields) {
          const v = Number(val[f.key]) || 0
          if (v > 0) obj[f.key] = v
        }
        // Use $set so Vue tracks this as reactive even when the key wasn't
        // present in the original API response (e.g. tenant with no saved weights).
        this.$set(this.model, 'scorecard_compiled_weights', Object.keys(obj).length ? JSON.stringify(obj) : '')
        this.onJsonValidation('scorecard_compiled_weights', '')
      }
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";

/* ========== Compiled Weights Panel ========== */
.weights-panel {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px 28px;
  background: #fff;
  max-width: 860px;
  margin: 4px auto;
}
.weights-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}
.weights-panel-title { font-size: 15px; font-weight: 600; color: #333; }
.weights-total-chip { font-size: 13px; font-weight: 700; padding: 3px 13px; border-radius: 20px; }
.chip-neutral { background: #e9ecef; color: #666; }
.chip-success { background: #d4edda; color: #155724; }
.chip-warning { background: #fff3cd; color: #856404; }
.weights-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px 40px; margin-bottom: 10px; }
.weight-row { display: flex; align-items: center; gap: 7px; }
.weight-metric-label { flex: 0 0 155px; font-size: 13px; color: #555; text-align: right; white-space: nowrap; }
.weight-btn { flex-shrink: 0; width: 26px; height: 26px; border: 1px solid #ced4da; background: #f8f9fa; border-radius: 4px; font-size: 15px; line-height: 1; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0; color: #333; }
.weight-btn:hover { background: #e2e6ea; }
.weight-btn:active { background: #d6d9dd; }
.weight-num { width: 50px; text-align: center; border: 1px solid #ced4da; border-radius: 4px; padding: 3px 4px; font-size: 14px; -moz-appearance: textfield; }
.weight-num::-webkit-inner-spin-button, .weight-num::-webkit-outer-spin-button { -webkit-appearance: none; }
.weight-pct { flex-shrink: 0; font-size: 12px; color: #999; }
.weight-bar-track { flex: 1; height: 5px; background: #e9ecef; border-radius: 3px; overflow: hidden; min-width: 30px; }
.weight-bar-fill { height: 100%; background: steelblue; border-radius: 3px; transition: width 0.15s ease; }
.weights-hint { font-size: 12px; color: #aaa; font-style: italic; margin: 6px 0 0 0; }
.weights-reset-btn { font-size: 12px; padding: 3px 10px; border: 1px solid #ced4da; background: #f8f9fa; border-radius: 4px; cursor: pointer; color: #555; }
.weights-reset-btn:hover { background: #e2e6ea; }

/* ========== Scorecard Thresholds Modal ========== */
.thresholds-modal-body { padding: 4px 8px; }
.thresholds-intro { font-size: 13px; color: #666; margin-bottom: 16px; }
.threshold-field-card { border: 1px solid #e9ecef; border-radius: 8px; padding: 14px 18px; margin-bottom: 12px; background: #fafafa; }
.threshold-field-header { display: flex; align-items: center; gap: 10px; margin-bottom: 10px; }
.threshold-field-label { font-size: 14px; font-weight: 600; color: #333; }
.threshold-field-direction { font-size: 12px; color: #888; font-style: italic; }
.threshold-inputs-row { display: flex; gap: 16px; align-items: center; flex-wrap: wrap; margin-bottom: 10px; }
.threshold-inputs-row-4 { gap: 10px; }
.threshold-input-group { display: flex; align-items: center; gap: 5px; }
.threshold-auto { opacity: 0.65; }
.threshold-tier-label { font-size: 12px; font-weight: 700; min-width: 56px; text-align: right; }
.threshold-operator { font-size: 13px; color: #555; min-width: 18px; text-align: center; }
.threshold-num { width: 68px; text-align: center; border: 1px solid #ced4da; border-radius: 4px; padding: 3px 6px; font-size: 14px; -moz-appearance: textfield; }
.threshold-num::-webkit-inner-spin-button, .threshold-num::-webkit-outer-spin-button { -webkit-appearance: none; }
.threshold-input-error { border-color: #dc3545 !important; background: #fff5f5; }
.threshold-computed { font-size: 14px; font-weight: 600; color: #555; min-width: 50px; }
.threshold-error-msg { font-size: 12px; color: #dc3545; margin-bottom: 6px; }
.threshold-color-bar { display: flex; height: 8px; border-radius: 4px; overflow: hidden; width: 100%; }
.threshold-bar-segment { transition: flex 0.2s ease; min-width: 2px; }
.bar-good     { background: #28a745; }
.bar-warning  { background: #ffc107; }
.bar-bad      { background: #dc3545; }
.bar-elite    { background: #28a745; }
.bar-solid    { background: #007bff; }
.bar-coaching { background: #ffc107; }
.tier-good     { color: #155724; }
.tier-warning  { color: #856404; }
.tier-bad      { color: #721c24; }
.tier-elite    { color: #155724; }
.tier-solid    { color: #004085; }
.tier-coaching { color: #856404; }
.thresholds-modal-footer { display: flex; justify-content: space-between; align-items: center; margin-top: 16px; padding-top: 12px; border-top: 1px solid #dee2e6; }

/* Remove button on optional field cards */
.threshold-remove-btn {
  margin-left: auto;
  background: none;
  border: none;
  font-size: 18px;
  line-height: 1;
  color: #999;
  cursor: pointer;
  padding: 0 4px;
  transition: color 0.15s;
}
.threshold-remove-btn:hover { color: #dc3545; }

/* Add Field row */
.threshold-add-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 0 4px;
  padding: 10px 14px;
  background: #f8f9fa;
  border: 1px dashed #ced4da;
  border-radius: 8px;
}

/* ========== Dual-handle gradient slider ========== */
.dual-range-wrap {
  position: relative;
  height: 32px;
  border-radius: 6px;
  margin: 10px 0 4px;
  box-shadow: inset 0 1px 3px rgba(0,0,0,0.2);
}
.dual-range-input {
  position: absolute;
  left: 0;
  width: 100%;
  height: 32px;
  margin: 0;
  padding: 0;
  background: transparent;
  -webkit-appearance: none;
  appearance: none;
  pointer-events: none;
  outline: none;
}
.dual-range-input::-webkit-slider-runnable-track {
  background: transparent;
  height: 32px;
  border-radius: 6px;
}
.dual-range-input::-moz-range-track {
  background: transparent;
  height: 32px;
  border-radius: 6px;
}
.dual-range-input::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  pointer-events: all;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fff;
  border: 2.5px solid #555;
  cursor: grab;
  box-shadow: 0 1px 4px rgba(0,0,0,0.35);
  margin-top: 5px;
  transition: border-color 0.1s, box-shadow 0.1s;
}
.dual-range-input::-webkit-slider-thumb:active {
  cursor: grabbing;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0,123,255,0.25);
}
.dual-range-input::-moz-range-thumb {
  pointer-events: all;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  border: 2.5px solid #555;
  cursor: grab;
  box-shadow: 0 1px 4px rgba(0,0,0,0.35);
}
.dual-range-input::-moz-range-thumb:active { cursor: grabbing; border-color: #007bff; }

/* Readout row below slider */
.slider-readout-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  margin-top: 6px;
}
.readout-end {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
}
.readout-tier { font-weight: 700; font-size: 12px; }
.readout-sep  { color: #888; font-size: 12px; }
.readout-unit { color: #666; font-size: 11px; }
.readout-center { display: flex; align-items: center; gap: 4px; font-size: 12px; }

/* 3-handle compiled score readout */
.compiled-readout-row { align-items: flex-start; }
.compiled-readout-row .readout-end { flex: 1; }
.compiled-readout-row .readout-center { flex: 0 0 auto; }
.tier-elite { color: #155724; font-weight: 700; }
</style>
